import * as React from 'react';
import * as styles from './style.css';
import UQButton from '../../../../uq-ui/components/button';
import { useDispatch, useSelector } from 'react-redux';
import { isMemorialType } from '../../../store/sticker-show/selectors';
import Icon from '../../../../../modules/icons/Icon';
import { useTranslation } from 'react-i18next';
import { currentUserInfoSelector } from '../../../../../modules/auth/store/auth-user/selectors';
import { useParams } from 'react-router';
import { useStickerItem } from '../../../store/sticker-show/hooks';
import ConfirmModal from '../../../../../modules/uq-ui/components/confirm-modal';
import { deleteStickerItem } from '../../../store/entities/sticker-items/actions';

export function GridItem({
  name,
  date,
  background,
  foreground,
  id,
  onClick,
}: {
  name?: string | null;
  date?: string | null;
  background: string[];
  foreground?: any;
  id: string;
  onClick: () => any;
}) {
  const image = background[0]; // We assume 1 image for now
  const { t } = useTranslation('scr-show-sticker-item');
  const isStickerTypeMemorial = useSelector(isMemorialType);
  const [deleteActive, setDeleteActive] = React.useState(false);
  const [confirmStickerDelete, setConfirmStickerDelete] = React.useState(false);
  const currentUser = useSelector(currentUserInfoSelector);
  const { id: stickerId }: { id: string } = useParams();
  const [stickerItem] = useStickerItem(stickerId, id);
  const isMySticker = currentUser.id === stickerItem?.from?.id;
  const dispatch = useDispatch();

  const onDelete = (e: Event) => {
    e.stopPropagation();
    setDeleteActive(true);
  };

  const onDeleteClick = (e: Event) => {
    e.stopPropagation();
    setConfirmStickerDelete(true);
    setDeleteActive(false);
  };

  const onDeleteCancelClick = (e: Event) => {
    e.stopPropagation();
    setDeleteActive(false);
  };

  const onModalDeleteClick = (e: Event) => {
    e.stopPropagation();
    setConfirmStickerDelete(false);
    dispatch(deleteStickerItem(stickerItem));
  };

  const onModalDeleteClose = (e: Event) => {
    e.stopPropagation();
    setConfirmStickerDelete(false);
  };

  return (
    <div className={styles.container} style={{ backgroundImage: 'url("' + image + '")' }} onClick={onClick}>
      {!!foreground && <div className={styles.foreground}>{foreground}</div>}
      <Icon className={styles.expandIcon} name={'Expand'} />
      {(name || date) && (
        <div className={styles.strip}>
          {name && <div className={styles.textAuthor}>{name}</div>}
          {date && <div className={styles.textDate}>{date}</div>}
          <div className={styles.deleteButton}>
            {!deleteActive && isMySticker && isStickerTypeMemorial && (
              <UQButton
                theme={isStickerTypeMemorial ? 'memorial' : 'white'}
                justIcon={true}
                label={''}
                icon={<Icon name={'TrashBlack'} />}
                onPress={onDelete}
              />
            )}
            {deleteActive && isMySticker && (
              <div className={isStickerTypeMemorial ? styles.deleteControls : styles.deleteControlsWhite}>
                <UQButton
                  theme={isStickerTypeMemorial ? 'white' : 'memorial'}
                  justIcon={true}
                  label={''}
                  containerStyle={{ height: 30 + 'px', width: 30 + 'px' }}
                  innerClass={styles.deleteConfirm}
                  icon={<Icon style={{ width: 14 + 'px' }} name={'CheckedBlack'} />}
                  onPress={onDeleteClick}
                />
                <span className={styles.deleteText}>{t('deleteButton')}</span>
                <UQButton
                  theme={isStickerTypeMemorial ? 'white' : 'memorial'}
                  justIcon={true}
                  label={''}
                  containerStyle={{ height: 30 + 'px', width: 30 + 'px' }}
                  innerClass={styles.deleteConfirm}
                  icon={<Icon style={{ width: 14 + 'px' }} name={'ModalCloseSmallDark'} />}
                  onPress={onDeleteCancelClick}
                />
              </div>
            )}
          </div>
        </div>
      )}
      <ConfirmModal
        show={confirmStickerDelete}
        title={t('deleteTitle')}
        styles={{ zIndex: 105 }}
        showConfirmBtn={false}
        onClose={onModalDeleteClose}
        isMemorialTheme={isStickerTypeMemorial}>
        <div className={styles.deleteModelContainer}>
          {t('deleteMessage')}
          <UQButton label={t('deleteButton')} containerClass={styles.attachFloatButton} theme={'danger'} onPress={onModalDeleteClick} />
        </div>
      </ConfirmModal>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/grid-item/index.tsx